import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { DEFAULT_LANG, LANGUAGES, translate } from "./translations";

const LangContext = createContext(null);
const STORAGE_KEY = "pazapa.lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANG;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    return LANGUAGES.includes(saved) ? saved : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", lang);
    }
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
    }
  }, [lang]);

  const setLang = (next) => {
    if (LANGUAGES.includes(next)) setLangState(next);
  };

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t: (key) => translate(lang, key),
      localized: (obj, base) => {
        if (!obj) return "";
        if (lang === "nl") return obj[`${base}_nl`] || obj[base] || "";
        return obj[base] || "";
      },
    }),
    [lang]
  );

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
